exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 760px) {\n.min-content-small-screen[data-v-86512ece] {\n    width: min-content;\n}\n}\n", ""]);

// exports
